import type { PermissionName } from "./catalog";

export const PERMISSIONS = {
  USER_VIEW: "user.view",
  USER_CREATE: "user.create",
  USER_UPDATE: "user.update",
  USER_DELETE: "user.delete",
  ROLE_VIEW: "role.view",
  ROLE_CREATE: "role.create",
  ROLE_UPDATE: "role.update",
  ROLE_DELETE: "role.delete",
  PERMISSION_VIEW: "permission.view",
  PERMISSION_CREATE: "permission.create",
  PERMISSION_UPDATE: "permission.update",
  PERMISSION_DELETE: "permission.delete",
  CATEGORIES_VIEW: "categories.view",
  CATEGORIES_CREATE: "categories.create",
  CATEGORIES_UPDATE: "categories.update",
  CATEGORIES_DELETE: "categories.delete",
  TAGS_VIEW: "tags.view",
  TAGS_CREATE: "tags.create",
  TAGS_UPDATE: "tags.update",
  TAGS_DELETE: "tags.delete",
  SETTINGS_VIEW: "settings.view",
  SETTINGS_CREATE: "settings.create",
  SETTINGS_UPDATE: "settings.update",
  SETTINGS_DELETE: "settings.delete",
  BRANCH_VIEW: "branch.view",
  BRANCH_CREATE: "branch.create",
  BRANCH_UPDATE: "branch.update",
  BRANCH_DELETE: "branch.delete",
  ITEMS_VIEW: "items.view",
  ITEMS_CREATE: "items.create",
  ITEMS_UPDATE: "items.update",
  ITEMS_DELETE: "items.delete",
  SUPPLIER_VIEW: "supplier.view",
  SUPPLIER_CREATE: "supplier.create",
  SUPPLIER_UPDATE: "supplier.update",
  SUPPLIER_DELETE: "supplier.delete",
  PO_VIEW: "po.view",
  PO_CREATE: "po.create",
  PO_UPDATE: "po.update",
  PO_DELETE: "po.delete",
  PO_CONFIRM: "po.confirm",
  VARIANTS_VIEW: "variants.view",
  VARIANTS_CREATE: "variants.create",
  VARIANTS_UPDATE: "variants.update",
  VARIANTS_DELETE: "variants.delete",
  BATCH_VIEW: "batch.view",
  BATCH_CREATE: "batch.create",
  BATCH_UPDATE: "batch.update",
  BATCH_DELETE: "batch.delete",
  INVENTORY_VIEW: "inventory.view",
  INVENTORY_CREATE: "inventory.create",
  OPENING_BALANCE_VIEW: "openingBalance.view",
  OPENING_BALANCE_CREATE: "openingBalance.create",
  OPENING_BALANCE_UPDATE: "openingBalance.update",
  OPENING_BALANCE_DELETE: "openingBalance.delete",
  TRANSFER_VIEW_INCOMING: "transfer.viewIncoming",
  TRANSFER_VIEW_OUTGOING: "transfer.viewOutgoing",
  TRANSFER_VIEW: "transfer.view",
  TRANSFER_CREATE: "transfer.create",
  TRANSFER_UPDATE: "transfer.update",
  TRANSFER_DELETE: "transfer.delete",
  TRANSFER_CONFIRM: "transfer.confirm",
  // CK Prepared Item Requests
  CK_REQUEST_PREPARED_ITEM_VIEW: "ckRequestPreparedItem.view",
  CK_REQUEST_PREPARED_ITEM_CONFIRM_QTY: "ckRequestPreparedItem.confirmQty",
  CK_REQUEST_PREPARED_ITEM_UPDATE: "ckRequestPreparedItem.update",
  CK_REQUEST_PREPARED_ITEM_SEND_ITEM: "ckRequestPreparedItem.sendItem",
  BRANCH_REQUEST_PREPARED_ITEM_VIEW: "branchRequestPreparedItem.view",
  BRANCH_REQUEST_PREPARED_ITEM_CREATE: "branchRequestPreparedItem.create",
  BRANCH_REQUEST_PREPARED_ITEM_UPDATE: "branchRequestPreparedItem.update",
} as const satisfies Record<string, PermissionName>;
